import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-ink text-cream/90 relative z-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <h3 className="font-serif text-3xl text-cream">Susanna Paoletti</h3>
          <p className="text-cream/60 text-sm uppercase tracking-[0.22em] mt-2">
            Psicologa e Psicoterapeuta
          </p>
          <p className="mt-6 text-cream/70 leading-relaxed max-w-sm">
            Studio privato a Macerata, Marche. Uno spazio di ascolto, comprensione e cambiamento.
          </p>
          <address className="mt-6 not-italic text-sm text-cream/70 space-y-1">
            <p>Via Emanuele Filiberto 1, 62100 Macerata (MC)</p>
            <p>
              Tel.{" "}
              <a href="tel:+393486921696" className="text-cream/80 hover:text-sage-light transition-colors">
                +39 348 692 1696
              </a>
            </p>
            <p>
              <a href="mailto:susannapaoletti11@gmail.com" className="text-cream/80 hover:text-sage-light transition-colors">
                susannapaoletti11@gmail.com
              </a>
            </p>
          </address>
          <p className="mt-6 text-sm text-cream/55">
            Iscrizione all'Albo: <span className="text-cream/80">Ordine degli Psicologi delle Marche n. 1078</span>
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.22em] text-cream/45 mb-5">Naviga</p>
          <ul className="space-y-3 text-cream/75">
            {[
              { l: "Chi sono", to: "/chi-sono" },
              { l: "Percorsi ed interventi", to: "/aree-di-intervento" },
              { l: "Aree di Intervento", to: "/aree-di-intervento#aree-intervento" },
              { l: "Approccio", to: "/approccio" },
              { l: "EMDR a Macerata", to: "/emdr-macerata" },
              { l: "Formazione", to: "/formazione" },
              { l: "Esperienze", to: "/esperienze" },
              { l: "FAQ", to: "/faq" },
              { l: "Contatti", to: "/contatti" },
            ].map((i) => (
              <li key={i.to}>
                <Link
                  to={i.to}
                  className="transition-colors duration-300 hover:text-sage-light"
                  data-testid={`footer-link-${i.to.replace("/", "")}`}
                >
                  {i.l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.22em] text-cream/45 mb-5">Informazioni legali</p>
          <ul className="space-y-3 text-cream/75">
            <li>
              <Link to="/privacy" className="transition-colors duration-300 hover:text-sage-light" data-testid="footer-link-privacy">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/privacy#cookie" className="transition-colors duration-300 hover:text-sage-light" data-testid="footer-link-cookie">
                Cookie Policy
              </Link>
            </li>
            <li>
              <button
                onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))}
                className="transition-colors duration-300 hover:text-sage-light text-left"
                data-testid="footer-cookie-preferences"
              >
                Gestione delle preferenze
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/45">
          <p>© {new Date().getFullYear()} Susanna Paoletti — Tutti i diritti riservati.</p>
          <p>Sede a Macerata, Marche · Professionista sanitaria in regola con l'assolvimento dell'obbligo formativo ECM.</p>
        </div>
      </div>
    </footer>
  );
};
